<script>
import i18n from '@/i18n';
import { h, resolveComponent, resolveDirective, withDirectives } from 'vue';

export default {
  name: 'cTitle',
  data() {
    return {};
  },
  props: {
    routeItem: {
      type: Array,
      default: () => {}
    },
    prefix: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    bgColor: {
      type: String,
      default: ''
    },
    root: {
      type: Boolean,
      default: false
    },
    fontSize: {
      type: Number,
      default: 24
    },
    deps: {
      type: Number,
      default: 1
    },
    infor: {
      type: Boolean,
      default: false
    },
    history: {
      type: Boolean,
      default: false
    },
    underline: {
      type: Boolean,
      default: false
    },
    rootPath: {
      type: String,
      default: '/'
    }
  },
  emits: ['back', 'itemClick', 'rootClick'],
  computed: {},
  methods: {
    onItemClick(item) {
      this.$emit('back', item);
    },
    onRouteClick(item) {
      this.$emit('itemClick', item);
    },
    onRootClick(item) {
      this.$emit('rootClick', item);
    }
  },
  render() {
    const { $theme, $slots, routeItem, name, fontSize, bgColor, root, underline, rootPath } = this;
    const rootName = i18n.global.t('label.home');
    const cLabel = resolveComponent('c-label');
    const legoIcon = resolveComponent('lego-icon');
    const cBreadcrumb = resolveComponent('c-breadcrumb');
    const legoTooltip = resolveDirective('lego-tooltip');
    const titleCo = h(
      'div',
      {
        class: ['c-title__item']
      },
      [
        this.history &&
          h(
            'div',
            {
              class: ['c-title__item__history'],
              onClick: this.onItemClick
            },
            [
              h(legoIcon, {
                iconType: 'df',
                icon: 'arrow_left_bold_24',
                iconSize: 24
              })
            ]
          ),
        this.prefix &&
          h(
            cLabel,
            {
              inline: true,
              size: root ? 22 : fontSize,
              weight: root ? 700 : 400,
              color: $theme.COLOR.PRIMARY.BASE
            },
            ()=>[this.prefix]
          ),
        h(
          cLabel,
          {
            inline: true,
            size: root ? 22 : fontSize,
            weight: root ? 700 : 400
          },
          ()=>[name || routeItem[routeItem.length - 1].text]
        ),
        this.infor &&
          withDirectives(
            h(legoIcon, {
              iconType: 'df',
              icon: 'info',
              id: 'manual',
              size: 20
            }),
            [[legoTooltip, name || routeItem[routeItem.length - 1].description]]
          ),
        $slots.sub
      ]
    );
    const utilCo = h(
      'div',
      {
        class: ['c-title__util']
      },
      [
        h(
          cBreadcrumb,
          {
            routeItem,
            rootPath,
            rootName,
            onRootClick: (e) => this.onRootClick(e),
            onItemClick: (e) => this.onRouteClick(e)
          },
          ()=>[name || routeItem[routeItem.length - 1].name]
        )
      ]
    );

    return h(
      'div',
      {
        class: [
          {
            'c-title': true,
            'c-title-root': root,
            'c-title-underline': underline
          }
        ]
      },
      [titleCo, $slots.default ? $slots.default() : routeItem ? utilCo : null]
    );
  }
};
</script>
<style lang="scss" scoped>
.c-title {
  display: flex;
  align-items: center;
  justify-content: space-between;

  &-root {
    height: 60px;
    align-items: flex-end;
    padding-bottom: 10px;
    border-bottom: 1px solid var(--color-ui-ui07);
  }

  &-underline {
    align-items: flex-end;
    padding-bottom: 8px;
    margin-bottom: 20px;
    border-bottom: 1px solid var(--color-ui-ui07);
  }

  &__item {
    display: flex;
    align-items: center;

    &__history {
      cursor: pointer;
    }

    .c-label + .c-label {
      margin-left: 8px;
    }

    :deep .opus-icon__arrow_left_bold_24 {
      height: 42px;
    }

    .opus-icon__info {
      margin-left: 8px;
    }
  }

  &__util {
  }
}
</style>
